// src/Components/UserCollection.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PaymentService from '../services/PaymentService';

const UserCollection = ({ userId }) => {
  const [collection, setCollection] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchUserCollection = async () => {
      try {
        setIsLoading(true);
        const nfts = await PaymentService.getUserCollection(userId);
        setCollection(nfts);
        setError(null);
      } catch (err) {
        setError('Failed to load your collection. Please try again later.');
        console.error('Error fetching collection:', err);
      } finally {
        setIsLoading(false);
      }
    };
    
    if (userId) {
      fetchUserCollection();
    }
  }, [userId]);
  
  const getRarityClass = (rarity) => {
    switch(rarity) {
      case 'common':
        return 'rarity-common';
      case 'uncommon':
        return 'rarity-uncommon';
      case 'rare':
        return 'rarity-rare';
      case 'epic':
        return 'rarity-epic';
      case 'legendary':
        return 'rarity-legendary';
      default:
        return 'rarity-common';
    }
  };
  
  if (isLoading) {
    return <div className="loading-container">Loading your collection...</div>;
  }
  
  if (error) {
    return <div className="error-container">{error}</div>;
  }
  
  if (collection.length === 0) {
    return (
      <div className="empty-collection">
        <h2>Your Collection</h2>
        <p>You don't own any NFTs yet. Start exploring the marketplace to find your first NFT!</p>
        <Link to="/" className="explore-button">Explore Marketplace</Link>
      </div>
    );
  }
  
  return (
    <div className="user-collection">
      <h2>Your Collection</h2>
      <p className="collection-info">
        All your purchased NFTs are stored in your secure wallet. You can view, transfer, or sell them anytime.
      </p>
      
      <div className="product-grid">
        {collection.map((nft) => (
          <div className="product-card-container" key={nft.id}>
            <Link to={`/nft/${nft.id}`} style={{ textDecoration: 'none' }}>
              <div className="product-card">
                <span className={`rarity-badge ${getRarityClass(nft.rarity)}`}>
                  {nft.rarity.charAt(0).toUpperCase() + nft.rarity.slice(1)}
                </span>
                <img 
                  src={nft.image} 
                  alt={nft.title} 
                  className="product-image" 
                />
                <div className="product-details">
                  <h3 className="product-title">{nft.title}</h3>
                  <div className="product-creator">
                    <img 
                      src={nft.creator.avatar} 
                      alt={nft.creator.name} 
                      className="creator-avatar" 
                    />
                    <span className="creator-name">{nft.creator.name}</span>
                  </div>
                  <div className="product-acquisition">
                    <span className="acquisition-date">Acquired: {new Date(nft.acquiredAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            </Link>
            <button className="view-3d-button">View in 3D</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserCollection;